import { Blank, Dropdown, Icon, IconButton, Input, OptionContainer, Popup } from "@evergis/ui";
import styled from "styled-components";
import { AddSystemAttributes } from "../../../DialogComponents/Attributes/AddSystemAttributes";
import { LayerReferences } from "../../../DialogComponents/Attributes/LayerReferences/LayerReferences";
import { AttributesBlockCheckbox } from "../../../DialogComponents/Attributes/styled";
import { AttributeBlank, AttributesList, RestrictedWidthContainer } from "../../../DialogComponents/styled";
import { StyledDialogActions } from "../../../SelectFiles/styled";
import { StyledDialogContent } from "../Project/styled";

export const QueryAttributesContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  flex-grow: 1;
  overflow-y: auto;

  ${AttributesBlockCheckbox} {
    margin: 0 0 1rem 12px;
  }
`;

export const QueryAttributeContainer = styled.div`
  display: flex;
  width: 100%;
  box-sizing: border-box;
  position: relative;
  align-items: center;
  background-color: ${({ theme }) => theme.palette.background};
  border-radius: 0.5rem;
  height: 4rem;
  padding: 1rem;
  gap: 0 1rem;

  &:hover {
    background-color: ${({ theme }) => theme.palette.element};
  }
`;

export const QueryAttributeMeta = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0 1rem;
  width: 100%;
`;

export const QueryAttributeType = styled.div`
  display: flex;
  align-items: center;
  gap: 0 0.25rem;
  font-size: 0.75rem;
  color: ${({ theme }) => theme.palette.textSecondary};
  line-height: 14px;

  ${Icon} {
    width: 14px;
    height: 14px;
  }

  ${Icon}:after {
    font-size: 14px;
    color: ${({ theme }) => theme.palette.textSecondary};
  }
`;

export const QueryAttributeActions = styled.div`
  display: flex;
  align-items: center;
  gap: 0 0.5rem;
  flex-shrink: 0;
`;

export const AttributeActionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0 1rem;
`;

export const AttributeAction = styled(OptionContainer)`
  display: flex;
  align-items: center;
  gap: 0 1rem;
`;

export const AttributeAliasContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0 0.25rem;

  ${Icon} {
    visibility: hidden;
  }

  &:hover {
    ${Icon} {
      visibility: visible;
    }
  }
`;

export const AttributeAliasText = styled.div<{ isDisplayField?: boolean }>`
  font-size: 14px;
  font-weight: ${({ isDisplayField }) => (isDisplayField ? "bold" : "normal")};
`;

export const AttributeAliasEdit = styled(Blank)`
  display: flex;
  align-items: center;
  box-sizing: border-box;
  padding: 1rem 0.5rem 1rem 1rem;
`;

export const StyledPopup = styled(Popup)`
  max-width: initial;
  width: auto;
`;

export const StyledIconButton = styled(IconButton)`
  width: 1rem;
  height: 1rem;
`;

export const QueryAttributeNewContainer = styled.div`
  display: flex;
  width: 100%;
  box-sizing: border-box;
  position: relative;
  align-items: center;
  background-color: ${({ theme }) => theme.palette.background};
  border-radius: 0.5rem;
  padding: 1rem;

  &:hover {
    background-color: ${({ theme }) => theme.palette.element};
  }
`;

export const StyledActionsBar = styled(StyledDialogActions)`
  padding-right: 0;
  padding-left: 0;
  width: 100%;
`;

export const StyledAddSystemAttributes = styled(AddSystemAttributes)`
  margin-left: 0;
`;

export const StyledContent = styled(StyledDialogContent)`
  flex-grow: 1;
  height: 100%;
  padding-left: 3rem;
  padding-right: 3rem;
  width: 100%;
  align-items: start;
  box-sizing: border-box;

  ${RestrictedWidthContainer} {
    width: auto;
  }

  ${AttributesList} {
    margin-top: 0;
  }
`;

export const StyledDropdown = styled(Dropdown)`
  margin-top: 2px;
  text-overflow: unset;
  border-bottom-right-radius: 0;
  border-top-right-radius: 0;
`;

export const NameInput = styled(Input)`
  border-radius: 0;
  border-right: none;
  border-left: none;
  margin-right: 0 !important;
`;

export const TypeDropdown = styled(StyledDropdown)`
  margin-top: 0;
`;

export const AliasInput = styled(Input)`
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  margin-top: 2px;
`;

export const StyledLayerReferences = styled(LayerReferences)`
  ${AttributeBlank} {
    box-shadow: none;
    border-radius: 0.5rem;

    &:hover {
      background-color: ${({ theme }) => theme.palette.element};
    }
  }
`;
